module.exports = __webpack_public_path__ + "static/p2-6bf7ac2de27532fcc023c75c9130af79.jpg";